"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var report_dto_1 = require("../dto/report-dto");
var table_grouping_category_builder_1 = require("./table-grouping-category-builder");
var row_category_builder_1 = require("./row-category-builder");
var column_measure_builder_1 = require("./column-measure-builder");
var column_category_with_add_measure_builder_1 = require("./column-category-with-add-measure-builder");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
/**
 * Report builder facilities. General usage example:
 *
 * <pre>
 *   let builder = ReportDtoBuilder();
 *   builder.addRowCategory('ProjectId').setCaption('Custom Title').setOrderType(OrderType.DESCENDING)
 *          .addRowCategory('DonorId').setTotalType(TotalType.BEFORE);
 *
 *   builder.build();
 * </pre>
 *
 * Created by Hayk.Andriasyan on 5/24/2017.
 */
var ReportDtoBuilder = /** @class */ (function () {
    function ReportDtoBuilder() {
        this._report = new report_dto_1.ReportDto();
        this._tableGroupingBuilder = new table_grouping_category_builder_1.TableGroupingCategoryBuilder(this._report);
    }
    ReportDtoBuilder.prototype.addTableGroupingCategory = function (categoryPathHolderId) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(categoryPathHolderId);
        return this._tableGroupingBuilder.addTableGroupingCategory(categoryPathHolderId);
    };
    ReportDtoBuilder.prototype.addRowCategory = function (categoryPathHolderId) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(categoryPathHolderId);
        var rowBuilder = new row_category_builder_1.RowCategoryBuilder(categoryPathHolderId);
        this._report.rowRootDto.children.push(rowBuilder.getElement());
        return rowBuilder;
    };
    ReportDtoBuilder.prototype.addColumnMeasure = function (measurePathHolderId) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(measurePathHolderId);
        var columnBuilder = new column_measure_builder_1.ColumnMeasureBuilder(measurePathHolderId);
        this._report.columnRootDto.children.push(columnBuilder.getElement());
        return columnBuilder;
    };
    ReportDtoBuilder.prototype.addColumnCategory = function (categoryPathHolderId) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(categoryPathHolderId);
        var columnBuilder = new column_category_with_add_measure_builder_1.ColumnCategoryWithAddMeasureBuilder(categoryPathHolderId);
        this._report.columnRootDto.children.push(columnBuilder.getElement());
        return columnBuilder;
    };
    ReportDtoBuilder.prototype.build = function () {
        var builtReport = this._report;
        this._report = null;
        return builtReport;
    };
    return ReportDtoBuilder;
}());
exports.ReportDtoBuilder = ReportDtoBuilder;
//# sourceMappingURL=report-dto-builder.js.map